import type { History } from 'history';
import { createBrowserHistory } from 'history';

import settings from 'src/settings';

// We use shallow rendering in almost all our Test. We like to keep it that way. The moment we try to call
// createBrowserHistory a DOM is needed. Due to the fact that shallow rendering does not provide a DOM we check if a
// DOM is provided before we call the function. Should there be no DOM an empty object is returned because the
// RouteComponent expects an object as a history prop.
const BrowserHistory = global.document
  ? createBrowserHistory({ basename: settings.VITE_APP_ROUTER_BASE_NAME })
  : ({} as History<unknown>);

export default BrowserHistory;
